import { InceptHeader } from '../../../constants/InceptHeader';
import { ConstructPost } from '../../../types/ConstructPost';
import { NonPaginatedResponse } from '../../../types/NonPaginatedResponse';
import { APPLICATION_BASE_PATH } from '../constants/applicationBasePath';

export const postDuplicateApplication = async (
  constructPost: ConstructPost,
  uuid: string,
  definitionName: string,
): Promise<NonPaginatedResponse<any> | undefined> =>
  constructPost(
    `${APPLICATION_BASE_PATH}/${uuid}/duplicate`,
    {
      headers: {
        [InceptHeader.DefinitionName]: definitionName,
      },
    },
    { preventDefaultErrorToast: true },
  );
